exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".CardWords-module__main__container__zMBSB {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    justify-content: center;\r\n}\r\n\r\n.CardWords-module__main_delete__CQ4v5 {\r\n    display: flex;\r\n    flex-direction: column;\r\n    flex-wrap: nowrap;\r\n}", ""]);

// exports
exports.locals = {
	"main__container": "CardWords-module__main__container__zMBSB",
	"main_delete": "CardWords-module__main_delete__CQ4v5"
};